import { useState, useEffect, useRef } from "react";
import { Box, CardMedia } from "@mui/material";

type Props = {
    imageURL: string,
    width?: string,
    height?: string,
    mr?: string,
    borderRadius?: string,
    invertColor?: boolean,
    onLoadStatus?: (loaded: boolean) => void;
}

const ImageLoader = ({ imageURL, height, width, mr, borderRadius, onLoadStatus, invertColor = false}: Props) => {

    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const currentImageURL = useRef<string>(imageURL);

    useEffect(() => {
        if (imageURL !== currentImageURL.current) {
            setIsImageLoaded(false);
            onLoadStatus?.(false);
            currentImageURL.current = imageURL;
        }
    }, [imageURL, onLoadStatus]);

    useEffect(() => {
        if (imageURL) {
            const img = new Image();
            img.src = imageURL;

            const handleImageLoad = () => {
                setIsImageLoaded(true);
                onLoadStatus?.(true);
            };

            const handleImageError = () => {
                console.error("Image failed to load");
                setIsImageLoaded(false);
                onLoadStatus?.(false);
            };

            img.onload = handleImageLoad;
            img.onerror = handleImageError;

            // Cleanup the image load listener in case the component unmounts or the URL changes
            return () => {
                img.onload = null;
                img.onerror = null;
            };
        }
    }, [imageURL, onLoadStatus]);

    return (
        <>
        {!isImageLoaded && (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CardMedia 
                sx={{
                    width: "26px",
                    height: "26px",
                    mr: mr ? mr : "0px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",   
                }}
                component="img"
                src={invertColor ? '/images/help-icon-black.png' : '/images/help-icon-white.png'}
            />
            </Box>
        )}
        {isImageLoaded && currentImageURL && (
            <CardMedia
            sx={{ 
                height: height ? height : "100%",
                width: width ? width : "100%",
                mr: mr ? mr : "0px",
                borderRadius: borderRadius ? borderRadius : "0px",
                objectFit: "fill"
            }}
            component="img"
            src={imageURL}
            />
        )}
        </>
    );
};

export default ImageLoader;